<div class="flag-dropdown-panel tw-bg-white tw-p-1">
  @if (registrant.hasComments()) {
    <div class="tw-flex tw-items-center tw-gap-1 tw-p-1">
      <button
        type="button"
        class="tw-flex tw-h-9 tw-w-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-start tw-gap-1.5 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-left tw-text-[13px] tw-font-medium tw-text-gray-700 tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100"
        (click)="viewComments()"
      >
        <i class="fas fa-comments tw-text-xs"></i> View comments
      </button>
    </div>
  }
  <div class="tw-flex tw-items-center tw-gap-1 tw-p-1">
    <button type="button" class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100" (click)="setFlag('green')">
      <i class="fas fa-flag tw-text-sm" style="color: #388e3c"></i>
    </button>
    <button
      type="button"
      class="tw-flex tw-h-9 tw-w-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-start tw-gap-1.5 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-left tw-text-[13px] tw-font-medium tw-text-gray-700 tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100"
      (click)="setFlagAndComment('green')"
    >
      <i class="fas fa-plus tw-text-xs"></i> Comment
    </button>
  </div>
  <div class="tw-flex tw-items-center tw-gap-1 tw-p-1">
    <button type="button" class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100" (click)="setFlag('orange')">
      <i class="fas fa-flag tw-text-sm" style="color: #f57c00"></i>
    </button>
    <button
      type="button"
      class="tw-flex tw-h-9 tw-w-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-start tw-gap-1.5 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-left tw-text-[13px] tw-font-medium tw-text-gray-700 tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100"
      (click)="setFlagAndComment('orange')"
    >
      <i class="fas fa-plus tw-text-xs"></i> Comment
    </button>
  </div>
  <div class="tw-flex tw-items-center tw-gap-1 tw-p-1">
    <button type="button" class="tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100" (click)="setFlag('red')">
      <i class="fas fa-flag tw-text-sm" style="color: #d32f2f"></i>
    </button>
    <button
      type="button"
      class="tw-flex tw-h-9 tw-w-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-start tw-gap-1.5 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-left tw-text-[13px] tw-font-medium tw-text-gray-700 tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100"
      (click)="setFlagAndComment('red')"
    >
      <i class="fas fa-plus tw-text-xs"></i> Comment
    </button>
  </div>
  @if (registrant.getFlagColor()) {
    <div class="tw-flex tw-items-center tw-gap-1 tw-p-1">
      <button
        type="button"
        class="tw-flex tw-h-9 tw-w-full tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-start tw-gap-1.5 tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-3 tw-text-left tw-text-[13px] tw-font-medium tw-text-gray-700 tw-transition-colors hover:tw-border-gray-400 hover:tw-bg-gray-50 active:tw-bg-gray-100"
        (click)="removeFlag()"
      >
        <i class="fas fa-trash tw-text-xs"></i> Remove Flag
      </button>
    </div>
  }
</div>
